import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";

const CLOUD_ROLE = "carteplus-ui-operator-scanner";

const browserHistory = createBrowserHistory();
export const reactPlugin = new ReactPlugin();
export const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_CONNECTION_STRING,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});

appInsights.loadAppInsights();

// Tag every event with a distinct cloud role so scanner telemetry is
// separable from the Operator UI even when the App Insights resource is shared.
appInsights.addTelemetryInitializer((envelope) => {
  envelope.tags = envelope.tags ?? [];
  envelope.tags["ai.cloud.role"] = CLOUD_ROLE;
});
appInsights.context.application.ver = CLOUD_ROLE;
